/** Defaults aligned with zoolife SpinWheelUiTheme::DEFAULTS */
export const SPIN_WHEEL_THEME_DEFAULTS = {
  title_text: '#06B6D4',
  title_text_end: '#1B1F25',
  badge_bg: '#FEF3C7',
  badge_text: '#F59E0B',
  badge_soldout_bg: '#F3F4F6',
  badge_soldout_text: '#4B5563',
  button_bg: '#22D3EE',
  button_bg_end: '#1B1F25',
  button_text: '#FFFFFF',
  slice_a: '#22D3EE',
  slice_a_end: '#0E7490',
  slice_b: '#F8FAFC',
  slice_b_end: '#E2E8F0',
  slice_label_on_a: '#0F172A',
  slice_label_on_b: '#334155',
  slice_icon_points: '#F59E0B',
  slice_icon_star: '#FBBF24',
  slice_icon_star_alt: '#94A3B8',
  ring_outer: '#FFFFFF',
  ring_border_from: '#FBBF24',
  ring_border_to: '#D97706',
  hub_border: '#FBBF24',
  dot_primary: '#FCD34D',
  dot_secondary: '#F8FAFC',
  wheel_bg_from: '#06B6D4',
  wheel_bg_to: '#0E7490',
  pointer_fill_from: '#FDE68A',
  pointer_fill_to: '#F59E0B',
  pointer_stroke_from: '#FCD34D',
  pointer_stroke_to: '#F59E0B',
};

function normalizeHex(value) {
  if (value == null) return null;
  let v = String(value).trim();
  if (!v) return null;
  if (v[0] !== '#') v = `#${v}`;
  if (!/^#[0-9A-Fa-f]{6}$/.test(v) && !/^#[0-9A-Fa-f]{3}$/.test(v)) return null;
  if (v.length === 4) {
    v = `#${v[1]}${v[1]}${v[2]}${v[2]}${v[3]}${v[3]}`;
  }
  return v.toUpperCase();
}

export function resolveSpinWheelTheme(input) {
  const out = { ...SPIN_WHEEL_THEME_DEFAULTS };
  if (!input || typeof input !== 'object') return out;
  Object.keys(SPIN_WHEEL_THEME_DEFAULTS).forEach((key) => {
    if (input[key] == null || input[key] === '') return;
    const hex = normalizeHex(input[key]);
    if (hex) out[key] = hex;
  });
  return out;
}

export function isValidSpinHex(c) {
  return /^#[0-9A-Fa-f]{6}$/.test(String(c || '').trim());
}

export function spinButtonGradientColors(theme) {
  const t = resolveSpinWheelTheme(theme);
  const end = t.button_bg_end && t.button_bg_end !== t.button_bg ? t.button_bg_end : t.button_bg;
  return [t.button_bg, end];
}

export function spinTitleGradientColors(theme) {
  const t = resolveSpinWheelTheme(theme);
  const end = t.title_text_end && t.title_text_end !== t.title_text ? t.title_text_end : t.title_text;
  return [t.title_text, end];
}
